var a="\n    if (a < 0.01) discard;\n";export{a as default};
